import React, { useState } from 'react';
import _ from 'lodash';
import * as Yup from 'yup';
import { FormContainer, InputItem, Item } from '~/views/places/styles';
import useEventListener from '~/hooks/use-event-listener';
import { Checkbox, InputGroup } from '~/components/form';
import { MdAdd, MdRemove } from 'react-icons/md';

export const PlaceSchema = Yup.object().shape({
  name: Yup.string().min(4, 'Verifique se o nome está correto').required('Informe o nome'),
});

export const PlaceForm = ({ values, errors, touched, previewMode, setFieldValue }) => {

  const [area, setArea] = useState('');

  useEventListener({
    name: 'keydown',
    handler: onKeyDown,
    elementId: 'events-places-areas',
  });

  function onKeyDown(event) {
    const charCode = event.which || event.keyCode;

    if (charCode === 27) {
      setArea('');
    }

    if (charCode === 13) {
      handleAddArea(area);
      setArea('');
      event.target.focus();
      event.preventDefault();
    }
  }

  const handleAddArea = (value) => {
    if (!_.includes(values.areas, value)) {
      let list = _.cloneDeep(values.areas || []);
      list.push(value);
      setFieldValue('areas', list);
    }
  };

  const handleRemoveArea = (index) => {
    if (index >= 0) {
      let list = _.cloneDeep(values.areas || []);
      list.splice(index, 1);
      setFieldValue('areas', list);
    }
  };

  const handleAddAreaBtn = () => {
    if (area) {
      handleAddArea(area);
      setArea('');
    }
  };

  return (
    <FormContainer>
      <Checkbox name='active' label='Ativo' />

      <InputGroup
        type="text"
        name="name"
        label="Nome"
        maxLength={100}
        disabled={previewMode}
        hasError={errors.name && touched.name} />

      <InputItem>
        <input
          id='events-places-areas'
          type='text'
          name='areas'
          label='Acesso'
          value={area}
          onChange={(event) => setArea(event.target.value)}
        />
        <label>Acessos</label>
        <div className="icon" onClick={handleAddAreaBtn}>
          <MdAdd />
        </div>
      </InputItem>
      
      {_.map(values.areas, (value, index) => (
        <Item key={index}>
          {value}
          <MdRemove onClick={() => handleRemoveArea(index)} />
        </Item>
      ))}
    </FormContainer>
  );
};
